module.exports = __webpack_public_path__ + "img/3.963d4e6d.jpg";